var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00083 15.8151C2.50426 10.866 6.78942 7 12 7C17.2106 7 21.4957 10.866 21.9992 15.8151C22.0036 15.8583 21.9908 15.8957 21.9558 15.9308C21.9175 15.9694 21.855 16 21.7771 16H19.2881C18.8828 12.4265 15.7744 9.64706 12 9.64706C8.22559 9.64706 5.11723 12.4265 4.71193 16H2.22291C2.145 16 2.08252 15.9694 2.04421 15.9308C2.00921 15.8957 1.99644 15.8583 2.00083 15.8151Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2354C14.8732 11.2354 17.2502 13.3062 17.6455 16.0001H14.875C14.5203 14.778 13.3675 13.8825 12 13.8825C10.6325 13.8825 9.47967 14.778 9.12502 16.0001H6.35446C6.74981 13.3062 9.12679 11.2354 12 11.2354Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.4706C12.4443 15.4706 12.8387 15.6785 13.0864 16H10.9136C11.1613 15.6785 11.5557 15.4706 12 15.4706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.158641d63422e0e4c1ed327ec870cdde.svg";
export { ForwardRef as ReactComponent };